enum TermsAndServicesType {
  BUYER = 'buyer',
  SELLER = 'seller',
}

export default TermsAndServicesType;
